import { render, staticRenderFns } from "./sglSingleEvent.vue?vue&type=template&id=83288780&scoped=true&"
import script from "./sglSingleEvent.vue?vue&type=script&lang=js&"
export * from "./sglSingleEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83288780",
  null
  
)

export default component.exports